module.exports = __webpack_public_path__ + "static/media/cptm_doc6.1b85bb0d.JPG";